// Centralised onboarding-completion flag.
//
// Why a wrapper instead of inlining `localStorage.setItem('onboarding_complete', 'true')`:
//
// 1. Versioning. If we materially redesign onboarding (new step, new
//    consent ask, etc.) we can bump ONBOARDING_VERSION and existing
//    users get pushed back through the new flow once. Without
//    versioning, the only escape was a different key name + 5
//    update sites, which is exactly the bug this replaces.
//
// 2. Cache vs source of truth. The user record on the backend
//    (`users.onboarding_completed`) is authoritative. localStorage is
//    purely a no-network cache so the OnboardingGuard can decide
//    instantly without an /api/auth/me round-trip. App.js + AuthPage
//    both refresh the cache from the backend on login/refresh.
//
// 3. Legacy migration. v1 stored a plain `'true'` string under
//    `onboarding_complete`. HasCompletedOnboarding() recognises that
//    as "done at v1" so existing users don't get re-onboarded just
//    because we shipped this versioning module.

const STORAGE_KEY = 'onboarding_complete';
const STORAGE_VERSION_KEY = 'onboarding_version';
export const ONBOARDING_VERSION = 1;

/** True iff the user finished onboarding at the current version. */
export function hasCompletedOnboarding() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw !== 'true') return false;
    const stored = parseInt(localStorage.getItem(STORAGE_VERSION_KEY) || '1', 10);
    return stored >= ONBOARDING_VERSION;
  } catch (_) {
    return false;
  }
}

/** Stamp completion for the current version. */
export function markOnboardingComplete() {
  try {
    localStorage.setItem(STORAGE_KEY, 'true');
    localStorage.setItem(STORAGE_VERSION_KEY, String(ONBOARDING_VERSION));
  } catch (_) {
    /* private mode / quota. Best effort */
  }
}

/** Drop both keys. Used by clearAuth on logout. */
export function clearOnboardingFlag() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_VERSION_KEY);
  } catch (_) {
    /* no-op */
  }
}
